import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface GlucoseSliderEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
}

export function GlucoseSliderEntryValue({
    value,
    inputLabel,
    size,
    className,
    ...props
}: GlucoseSliderEntryValueProps) {
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <div className="flex flex-col gap-2">
                <p className={cn(size === "sm" ? "text-sm" : size === "lg" ? "text-xl" : "text-md")}>
                    Glucose {String(value)}{" "}
                </p>
                <div style={{ width: "120px" }} className="relative bg-slate-300 rounded-full h-2">
                    <div
                        style={{
                            width: `${(Number(value) * 120) / 30}px`,
                        }}
                        className={cn(
                            "absolute left-0 top-0 h-full rounded-full bg-lime-500",
                            Number(value) > 20 && "bg-red-500",
                            Number(value) < 5 && "bg-red-500"
                        )}
                    />
                </div>
            </div>
        </BaseEntryValue>
    );
}
